export default __webpack_public_path__ + "static/media/icon_data.05015ddf.png";